import { defineStore } from 'pinia'
import { sendApi } from '@/utils/api'
export const useUploadStore = defineStore('upload', {
    actions: {
        async manyMedia(data){
            try{
                return await sendApi({
                    control: 'upload',
                    action: 'upload_many_media',
                    data: data,
                })
            }catch(e){
                console.error(e)
                return false;
            }
        },
        async manyMediaDeleteId(id){
            try {
                const res = await sendApi({
                    control: 'upload',
                    action: 'delete_media_by_id',
                    data: { id: id },
                })
                return res.status === 'success'
            } catch (e) {
                console.error(e)
                return false;
            }
        },
        async singleImage(data) {
            try {
                return await sendApi({
                    action: 'upload_single_image',
                    data: data, 
                    control:'upload'
                });
            } catch (e) {
                console.error(e);
                return false
            }
        }
    }
})